export class RequestCharge {
  chargeDate: Date;
  requestId: number;
  chargeTypeId: number;
  chargeTypeName: string;
  chargeGroupId: number;
  amount: number;
  description: string;
  isCanceled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-charge.ts